import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from './Auth';
import NotificationModule from './Notification';
import UserModule from './User';
import EmailModule from './Email';
import CreditsAmountModule from './CreditsAmount';
import SubscriptionModule from './Subscription';
import TransactionModule from './Transaction';
import PaymentModule from './Payment';
import DonationsModule from './Donations';
import SurveyModule from './Survey';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    AuthModule,
    NotificationModule,
    UserModule,
    EmailModule,
    CreditsAmountModule,
    SubscriptionModule,
    TransactionModule,
    PaymentModule,
    DonationsModule,
    SurveyModule,
  },
});



// WEBPACK FOOTER //
// ./src/stores/index.js